import { render, staticRenderFns } from "./SelectOrder.vue?vue&type=template&id=2c9d9854&scoped=true&"
import script from "./SelectOrder.vue?vue&type=script&lang=js&"
export * from "./SelectOrder.vue?vue&type=script&lang=js&"
import style0 from "./SelectOrder.vue?vue&type=style&index=0&id=2c9d9854&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9d9854",
  null
  
)

export default component.exports